import { QuoteSubview, QuoteView } from './types'

// Keep in sync with FullViewUrlQuery.cs
export function getQuoteSubview(type: QuoteSubview | QuoteView) {
  return Object.values(QuoteSubview).find((value) => value === type) ?? null
}

// Keep in sync with FullViewUrlQuery.cs
export function getQuoteView(type: QuoteView | QuoteSubview) {
  switch (getQuoteSubview(type)) {
    case QuoteSubview.Dividends:
    case QuoteSubview.Eearnings:
    case QuoteSubview.Revenue:
      return QuoteView.Financials
    case QuoteSubview.OptionsChain:
    case QuoteSubview.OptionsVolatility:
      return QuoteView.Options
    case null:
      return QuoteView.ChartDetail // No subview is active == chart detail
    default:
      return null // Eg. Short interest doesn’t belong to any parent group
  }
}
